export const getFileExt = (filename: string, hideDot?: boolean): string => {
  const fileParts = filename.split('.')
  const extension = fileParts.length === 0 ? null : fileParts[fileParts.length - 1].toLowerCase()
  const dot = hideDot ? '' : '.'

  return `${dot}${extension}`
}
